// @oasis-permission-inherits: /ltv (ltv:view)
import { createFileRoute } from "@tanstack/react-router";

import { Button } from "~/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "~/components/ui/table";
import { ensureSession } from "~/modules/auth/credentials";
import { JsonCell } from "~/modules/ltv/components";
import { appsflyerSendAuditQuery } from "~/modules/ltv/queries";

export const Route = createFileRoute("/_dash/ltv/appsflyer-send-audit")({
  component: RouteComponent,
  beforeLoad() {
    ensureSession();
  },
});

function RouteComponent() {
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    appsflyerSendAuditQuery.useInfiniteQuery({ params: {} });

  const rows = data?.pages.flatMap((p) => p.rows) ?? [];

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold">AppsFlyer Send Audit</h1>
      {isLoading && <p className="text-muted-foreground">Loading...</p>}
      {data && (
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">{rows.length} rows loaded</p>
          <div className="rounded-md border">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead className="bg-orange-50">AF Content ID</TableHead>
                  <TableHead className="bg-orange-50">AF Order ID</TableHead>
                  <TableHead className="bg-orange-50">AF Price</TableHead>
                  <TableHead className="bg-orange-50">AF Revenue</TableHead>
                  <TableHead className="bg-orange-50">AF Renewal</TableHead>
                  <TableHead className="bg-orange-50">AF IDFA</TableHead>
                  <TableHead className="bg-orange-50">AF IDFV</TableHead>
                  <TableHead className="bg-orange-50">AF IP</TableHead>
                  <TableHead className="bg-orange-50">AF OS</TableHead>
                  <TableHead className="bg-orange-50">AF Bundle ID</TableHead>
                  <TableHead className="bg-orange-50">AF App ID</TableHead>
                  <TableHead className="bg-orange-50">Customer User ID</TableHead>
                  <TableHead className="bg-orange-50">AF AppsFlyer ID</TableHead>
                  <TableHead className="bg-orange-50">AF Event Name</TableHead>
                  <TableHead className="bg-orange-50">AF Event Time</TableHead>
                  <TableHead>Processed At</TableHead>
                  <TableHead>Status</TableHead>
                  <TableHead>Skip Reason</TableHead>
                  <TableHead>Dry Run</TableHead>
                  <TableHead>Raw AppsFlyer Event</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {rows.map((row, i) => (
                  <TableRow key={i}>
                    <TableCell className="bg-orange-50 text-xs">
                      {row.af_content_id ?? "—"}
                    </TableCell>
                    <TableCell className="bg-orange-50 text-xs">{row.af_order_id ?? "—"}</TableCell>
                    <TableCell className="bg-orange-50 text-xs">{row.af_price ?? "—"}</TableCell>
                    <TableCell className="bg-orange-50 text-xs">{row.af_revenue ?? "—"}</TableCell>
                    <TableCell className="bg-orange-50 text-xs">{row.af_renewal ?? "—"}</TableCell>
                    <TableCell className="bg-orange-50 text-xs">{row.af_idfa ?? "—"}</TableCell>
                    <TableCell className="bg-orange-50 text-xs">{row.af_idfv ?? "—"}</TableCell>
                    <TableCell className="bg-orange-50 text-xs">{row.af_ip ?? "—"}</TableCell>
                    <TableCell className="bg-orange-50 text-xs">{row.af_os ?? "—"}</TableCell>
                    <TableCell className="bg-orange-50 text-xs">
                      {row.af_bundle_id ?? "—"}
                    </TableCell>
                    <TableCell className="bg-orange-50 text-xs">{row.af_app_id ?? "—"}</TableCell>
                    <TableCell className="bg-orange-50 text-xs">
                      {row.af_customer_user_id ?? "—"}
                    </TableCell>
                    <TableCell className="bg-orange-50 text-xs">
                      {row.af_appsflyer_id ?? "—"}
                    </TableCell>
                    <TableCell className="bg-orange-50 text-xs">
                      {row.af_event_name ?? "—"}
                    </TableCell>
                    <TableCell className="bg-orange-50 text-xs">
                      {row.af_event_time ?? "—"}
                    </TableCell>
                    <TableCell>
                      {row.processed_at ? new Date(row.processed_at.value).toLocaleString() : "—"}
                    </TableCell>
                    <TableCell>{row.status ?? "—"}</TableCell>
                    <TableCell>{row.skip_reason ?? "—"}</TableCell>
                    <TableCell>
                      {row.is_dry_run == null && "—"}
                      {row.is_dry_run === true && "Yes"}
                      {row.is_dry_run === false && "No"}
                    </TableCell>
                    <TableCell>
                      <JsonCell value={row.raw_appsflyer_event} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
          {hasNextPage && (
            <div className="flex justify-center">
              <Button
                variant="outline"
                onClick={() => fetchNextPage()}
                disabled={isFetchingNextPage}
              >
                {isFetchingNextPage ? "Loading..." : "Load more"}
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
